import React from 'react';

import PropTypes from 'prop-types';

import styled, { css } from 'styled-components';

import promoColors from 'theme/promoColors';
import promoMedia from 'theme/promoMedia';

const CommonButtonStyles = css`
    border-radius: 32px;
    cursor: pointer;
    display: block;
    font-size: 16px;
    line-height: 21px;
    font-weight: 500;
    outline: none;
    padding: 16px;
    text-align: center;
    text-decoration: none;
    box-sizing: border-box;

    ${promoMedia.tablet744} {
        min-width: 152px;
    }

    ${promoMedia.desktop1440} {
        padding: 14px 24px;
        min-width: auto;
    }
`;
const theme = {
    primary: css`
        background-color: ${promoColors.primary};
        color: ${promoColors.white};
        ${CommonButtonStyles};

        &:hover {
            background-color: ${promoColors.purple20};
            color: ${promoColors.primary};
        }

        &:link,
        &:visited {
            color: ${promoColors.white};
        }

        &:link:hover,
        &:visited:hover {
            color: ${promoColors.primary};
        }

        &:focus-visible {
            background-color: ${promoColors.purple20};
            color: ${promoColors.primary};
            outline: 1px dashed ${promoColors.primary};
        }
    `,
    secondary: css`
        background-color: ${promoColors.white};
        color: ${promoColors.primary};
        ${CommonButtonStyles};

        &:hover {
            background-color: ${promoColors.purple20};
        }

        &:link,
        &:visited {
            color: ${promoColors.primary};
        }

        &:focus-visible {
            background-color: ${promoColors.purple5};
            outline: 1px dashed ${promoColors.purple40};
        }
    `,
};
const SignButton = styled.a`
    ${({ fashion }) => fashion === 'primary' && theme.primary};
    ${({ fashion }) => fashion === 'secondary' && theme.secondary};
`;
const StylishButton = (props) => {
    return (
        <SignButton fashion={props.fashion} href={props.href} id={props.id} onClick={props.onClick} tabIndex={'0'} target={props.targetBlank ? '_blank' : null}>
            {props.caption}
        </SignButton>
    );
};

StylishButton.propTypes = {
    caption: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    href: PropTypes.string,
    id: PropTypes.string,
    fashion: PropTypes.oneOf(['primary', 'secondary']),
    onClick: PropTypes.func,
    targetBlank: PropTypes.bool,
};
export default StylishButton;
